<template>
  <div
    class="ipl-modal"
    v-if="show"
  >
    <div
      class="ipl-modal__backdrop"
      @click="disableBackdropClose ? $emit('close') : null"
    />
    <div class="ipl-modal__content">
      <slot />
    </div>
    <span
      class="ipl-modal__close-btn"
      @click="$emit('close')"
    >&times;</span>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  data() {
    return {
      bodyClassAdded: false,
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    disableBackdropClose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    appendBodyClass() {
      this.bodyClassAdded = true
      document.body.classList.add('modal-shown')
    },
    removeBodyClass() {
      this.bodyClassAdded = false
      document.body.classList.remove('modal-shown')
    },

  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.appendBodyClass()
        } else {
          this.removeBodyClass()
        }
      },
    },
  },
  created() {
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.$emit('close')
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  },
  beforeDestroy() {
    if (this.bodyClassAdded) {
      this.removeBodyClass()
    }
  },
  mounted() {
    if (this.show) {
      this.appendBodyClass()
    }
  },

}
</script>

<style>
  .ipl-modal {
    position: fixed;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    z-index: 1000;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .ipl-modal__close-btn {
    background: rgba(0, 13, 38, 0.9);
    height: 40px;
    position: fixed;
    right: 20px;
    top: 20px;
    width: 40px;
    font-size: 40px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    text-align: center;
    border-radius: 40px;
    box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.2);
  }

  .ipl-modal__backdrop {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 13, 38, 0.9);
  }

  .ipl-modal__content {
    margin: 0 20px;
    max-height: calc(100vh - 10px);
    overflow: auto;
    position: relative;
    width: 100%;
    max-width: 800px;

  }
</style>
